import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, money, STATUS } from "@/lib/api";
import { PageTitle } from "@/components/admin/AdminLayout";

const Stat = ({ label, value, accent, id }) => (
  <div className="rounded-2xl bg-[#111827] border border-white/10 p-5">
    <p className="text-xs uppercase tracking-widest text-slate-500">{label}</p>
    <p className={`font-mono text-2xl sm:text-3xl font-bold mt-2 ${accent}`} data-testid={`stat-${id}`}>{value}</p>
  </div>
);

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { http.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-500">Carregando...</p>;
  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Visão geral" sub="Resumo da sua loja" />
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
        <Stat label="Pedidos pendentes" value={s.pending_orders} accent="text-amber-300" id="pending" />
        <Stat label="Total de pedidos" value={s.total_orders} accent="text-white" id="orders" />
        <Stat label="Receita Pix" value={money(s.revenue_brl, "BRL")} accent="text-emerald-300" id="revenue-brl" />
        <Stat label="Receita MB Way" value={money(s.revenue_eur, "EUR")} accent="text-rose-300" id="revenue-eur" />
        <Stat label="Produtos ativos" value={s.active_products} accent="text-violet-300" id="products" />
        <Stat label="Categorias" value={s.categories} accent="text-cyan-300" id="categories" />
      </div>
      <div className="mt-10 rounded-2xl bg-[#111827] border border-white/10">
        <div className="flex justify-between items-center p-5 border-b border-white/10">
          <p className="font-heading font-bold">Pedidos recentes</p>
          <Link to="/admin/pedidos" className="text-sm text-violet-400 hover:text-violet-300" data-testid="dashboard-all-orders-link">Ver todos</Link>
        </div>
        {s.recent_orders.length === 0 ? <p className="p-5 text-sm text-slate-500">Nenhum pedido ainda.</p> : s.recent_orders.map((o) => (
          <div key={o.id} className="flex flex-wrap items-center gap-3 justify-between px-5 py-3 border-b border-white/5 last:border-0 text-sm">
            <span className="font-mono font-semibold w-20">{o.code}</span>
            <span className="flex-1 truncate text-slate-300">{o.customer_name}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full border ${STATUS[o.status].cls}`}>{STATUS[o.status].label}</span>
            <span className="font-mono w-28 text-right">{money(o.total, o.currency)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
